import { axios } from '../config/axios';

const endPoint = '/project/evaluator';

const getEvaluatorDashboardSummary = () => {
    return axios.get(`${endPoint}/dashboard`);
};

const getEvaluatorExamCandidates = ({ projectMasterId, status, page, limit }) => {
    const params = {};
    if (page)   params.page   = page;
    if (limit)  params.limit  = limit;
    if (status) params.status = status;
    return axios.get(`${endPoint}/exams/${projectMasterId}/candidates`, { params });
};

export {
    getEvaluatorDashboardSummary,
    getEvaluatorExamCandidates,
};
